import axios from "axios";
import { useEffect, useState } from "react";
import styles from "./Approval.module.css";

const Approval = () => {
  const [unapprovedVendors, setUnapprovedVendors] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  // Function to fetch unapproved vendors
  useEffect(() => {
    const fetchUnapprovedVendors = async () => {
      try {
        const token = localStorage.getItem("authToken"); // Get the token from localStorage

        const response = await axios.get(
          "https://prod.toxboxai.com/auth/unapproved-vendors",
          {
            headers: { Authorization: `Bearer ${token}` }, // Send the token in the request headers
          }
        );

        setUnapprovedVendors(response.data); // Store the unapproved vendors in state
      } catch (error) {
        setErrorMessage(
          error.response
            ? error.response.data.message
            : "Failed to fetch unapproved vendors"
        );
      }
    };

    fetchUnapprovedVendors();
  }, []); // Fetch unapproved vendors when the component mounts

  // Function to approve a vendor
  const handleApprove = async (userId) => {
    try {
      const token = localStorage.getItem("authToken"); // Get the token from localStorage

      // Send PUT request to approve the vendor
      const response = await axios.put(
        `https://prod.toxboxai.com/auth/approve/${userId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }, // Include token for authentication
        }
      );

      // Show success message
      alert(response.data.message);

      // Re-fetch the unapproved vendors list to update the UI
      const updatedVendors = unapprovedVendors.filter(
        (vendor) => vendor.userId !== userId
      );
      setUnapprovedVendors(updatedVendors);
    } catch (error) {
      alert(
        error.response
          ? error.response.data.message
          : "Failed to approve vendor"
      );
    }
  };

  return (
    <div className={styles.approve}>
      <h1>Unapproved Client</h1>
      {errorMessage && <p>{errorMessage}</p>}
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>User ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {unapprovedVendors.map((vendor) => (
            <tr key={vendor._id}>
              <td>{vendor.name}</td>
              <td>{vendor.email}</td>
              <td>{vendor.userId}</td>
              <td>
                {/* Approve button */}
                <button onClick={() => handleApprove(vendor.userId)}>
                  Approve
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default Approval;
